var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-welcome"},[_c('h2',[_vm._v("Welcome !")]),_c('p',[_vm._v("欢迎使用 ~")])])
}]

export { render, staticRenderFns }